// extracted by mini-css-extract-plugin
export default {"farmersCountBlock":"enslosures_farmersCountBlock__NMECK"};